/**
 * Fuse Node Component
 *
 * Node for fusing multiple images together.
 */

import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData } from '@/types/imageWorkflow';

const FuseNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;

  return (
    <BaseNode id={id} data={nodeData} type="fuse" selected={selected} hasTargetHandle={false}>
      {/* Multiple input handles for fuse node */}
      <Handle
        type="target"
        position={Position.Left}
        id="input-1"
        style={{ top: '30%' }}
        className="w-3 h-3 !bg-gray-400 border-2 border-white"
      />
      <Handle
        type="target"
        position={Position.Left}
        id="input-2"
        style={{ top: '70%' }}
        className="w-3 h-3 !bg-gray-400 border-2 border-white"
      />

      {nodeData.prompt ? (
        <div className="space-y-1">
          <div className="text-gray-500">Fuse prompt:</div>
          <div className="line-clamp-2 text-gray-700">{String(nodeData.prompt)}</div>
          {nodeData.model && nodeData.model !== 'auto' && (
            <div className="text-gray-400 mt-1">Model: {String(nodeData.model)}</div>
          )}
        </div>
      ) : (
        <div className="text-gray-400 italic">
          Click to configure fusion
          <div className="text-xs mt-1">Accepts 2+ inputs</div>
        </div>
      )}
    </BaseNode>
  );
};

export const FuseNode = memo(FuseNodeComponent);
export default FuseNode;
